// Centralised content sourced from satdiagnostic.com plus curated copy

export const CLINIC = {
  name: "Shri Anandpur Trust",
  fullName: "Shri Anandpur Trust Charitable Diagnostic Centre",
  tagline: "Service to mankind is service to God",
  promise: "Empowering health, enriching lives—together we diagnose, heal, and build a healthier future for all.",
  established: 1954,
  phone: "+91-98112-98451",
  phoneRaw: "919811298451",
  altPhone: "+91-11-71557647",
  email: "info@satdiagnostic.com",
  address: "C9/5, Krishna Nagar, New Delhi 110051, India",
  whatsapp: "919811298451",
  mapEmbed:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3501.5!2d77.2762!3d28.6618!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cfd2c6e0a4c89%3A0x0!2sKrishna+Nagar%2C+New+Delhi!5e0!3m2!1sen!2sin!4v1700000000000",
  logo: "https://img1.wsimg.com/isteam/ip/a677c0cf-1124-4ab0-a6c2-e08aa9227c21/SATCDClogo.png/:/rs=h:200,cg:true,m/qt=q:95",
};

export const STATS = [
  { label: "Years of Trust", value: 70, suffix: "+" },
  { label: "Patients Served", value: 500000, suffix: "+", short: "5L+" },
  { label: "Expert Doctors", value: 30, suffix: "+" },
  { label: "Diagnostic Services", value: 20, suffix: "+" },
];

export const TRUST_BADGES = [
  { label: "NABL Accredited Path Lab", icon: "ShieldCheck" },
  { label: "Charitable Trust • Est. 1954", icon: "HeartHandshake" },
  { label: "1.5 Tesla MRI · 16-Slice CT", icon: "Sparkles" },
  { label: "Free Dialysis Facility", icon: "Activity" },
];

export const SERVICES = [
  {
    slug: "mri",
    name: "MRI Scan",
    short: "1.5 Tesla MRI",
    icon: "Brain",
    blurb:
      "High-resolution MRI imaging on a 1.5 Tesla scanner — precise, painless and radiation-free.",
    image:
      "https://images.unsplash.com/photo-1666214280352-db292c05fd80?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    details: [
      "Whole body MRI",
      "Brain, Spine & Joints",
      "MR Angiography",
      "Soft-tissue evaluation",
    ],
    preparation:
      "Wear loose metal-free clothing. Inform our team about any implants, pacemakers, or pregnancy before the scan.",
    de: {
      name: "MRT-Untersuchung",
      short: "1,5 Tesla MRT",
      blurb:
        "Hochauflösende MRT-Bildgebung mit einem 1,5-Tesla-Scanner — präzise, schmerzfrei und strahlungsfrei.",
      details: [
        "Ganzkörper-MRT",
        "Gehirn, Wirbelsäule & Gelenke",
        "MR-Angiographie",
        "Weichteilbeurteilung",
      ],
      preparation:
        "Tragen Sie lockere, metallfreie Kleidung. Informieren Sie uns vor der Untersuchung über Implantate, Herzschrittmacher oder eine Schwangerschaft.",
    },
  },
  {
    slug: "ct-scan",
    name: "CT Scan",
    short: "16-Slice CT",
    icon: "ScanLine",
    blurb:
      "Fast, detailed cross-sectional imaging powered by a 16-slice multi-detector CT scanner.",
    image:
      "https://images.unsplash.com/photo-1666214282459-c7dff167ecc0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    details: [
      "CT Brain & Chest",
      "CT Angiography",
      "Contrast & Non-contrast",
      "Whole abdomen imaging",
    ],
    preparation:
      "Fast for 4 hours if contrast is required. Carry previous reports and prescriptions.",
    de: {
      name: "CT-Untersuchung",
      short: "16-Schicht-CT",
      blurb:
        "Schnelle, detaillierte Schnittbildgebung mit einem 16-Schicht-Multidetektor-CT-Scanner.",
      details: [
        "CT Gehirn & Thorax",
        "CT-Angiographie",
        "Mit und ohne Kontrastmittel",
        "Bildgebung des gesamten Abdomens",
      ],
      preparation:
        "Bei Kontrastmittelgabe 4 Stunden nüchtern bleiben. Bringen Sie frühere Befunde und Rezepte mit.",
    },
  },
  {
    slug: "dialysis",
    name: "Day-Care Dialysis",
    short: "Free Hemodialysis",
    icon: "Droplets",
    blurb:
      "A new dimension of charitable service — hemodialysis offered free of cost in a clean, monitored ward.",
    image:
      "https://images.unsplash.com/photo-1615461065929-4f8ffed6ca40?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    details: [
      "Free of cost dialysis",
      "Trained nephrology team",
      "Hygienic day-care ward",
      "Pre & post counselling",
    ],
    preparation:
      "Carry recent KFT, viral marker and physician referral. Eat a light meal before your session.",
    de: {
      name: "Tages-Dialyse",
      short: "Kostenlose Hämodialyse",
      blurb:
        "Eine neue Dimension wohltätigen Dienstes — Hämodialyse kostenfrei in einer sauberen, überwachten Station.",
      details: [
        "Kostenfreie Dialyse",
        "Erfahrenes Nephrologie-Team",
        "Hygienische Tagesstation",
        "Vor- und Nachgespräche",
      ],
      preparation:
        "Bringen Sie aktuelle Nierenwerte, Virusmarker und eine ärztliche Überweisung mit. Essen Sie vorher eine leichte Mahlzeit.",
    },
  },
  {
    slug: "cardiology",
    name: "Cardiology",
    short: "ECG · ECHO · TMT",
    icon: "HeartPulse",
    blurb:
      "Complete cardiac evaluation — 2D ECHO, ECG and Treadmill Test reported by experienced cardiologists.",
    image:
      "https://images.unsplash.com/photo-1682706841289-9d7ddf5eb999?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    details: ["2D Echo", "ECG", "TMT", "Cardiology consultation"],
    preparation:
      "For TMT, avoid heavy meals 2 hours prior and wear comfortable walking shoes.",
    de: {
      name: "Kardiologie",
      short: "EKG · ECHO · Belastungs-EKG",
      blurb:
        "Komplette Herzuntersuchung — 2D-ECHO, EKG und Belastungs-EKG, befundet durch erfahrene Kardiologen.",
      details: ["2D-Echokardiographie", "EKG", "Belastungs-EKG", "Kardiologische Sprechstunde"],
      preparation:
        "Beim Belastungs-EKG bitte 2 Stunden vorher keine schwere Mahlzeit und bequeme Schuhe tragen.",
    },
  },
  {
    slug: "pathology",
    name: "Pathology Lab",
    short: "NABL accredited",
    icon: "TestTube",
    blurb:
      "Fully automated Path Lab with NABL accreditation — biochemistry, haematology, microbiology and more.",
    image:
      "https://images.unsplash.com/photo-1582719471384-894fbb16e074?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    details: [
      "Routine blood & urine",
      "Biochemistry & Hormones",
      "Histopathology & Cytology",
      "Microbiology & Cultures",
    ],
    preparation:
      "Most tests require 8-12 hours fasting. Confirm with the lab when booking.",
    de: {
      name: "Pathologielabor",
      short: "NABL-akkreditiert",
      blurb:
        "Vollautomatisiertes Pathologielabor mit NABL-Akkreditierung — Biochemie, Hämatologie, Mikrobiologie und mehr.",
      details: [
        "Routine-Blut- und Urinanalyse",
        "Biochemie & Hormone",
        "Histopathologie & Zytologie",
        "Mikrobiologie & Kulturen",
      ],
      preparation:
        "Die meisten Tests erfordern 8–12 Stunden Nüchternheit. Bitte bei der Buchung bestätigen.",
    },
  },
  {
    slug: "dental",
    name: "Dental Care",
    short: "Implants · OPG",
    icon: "Smile",
    blurb:
      "Family dentistry, oral & maxillofacial surgery, implants and digital OPG imaging.",
    image:
      "https://images.unsplash.com/photo-1629909613654-28e377c37b09?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    details: [
      "Implants & Crowns",
      "Root canal treatment",
      "Digital OPG / IOPA",
      "Pediatric dentistry",
    ],
    preparation: "Bring previous X-rays and a list of current medications.",
    de: {
      name: "Zahnmedizin",
      short: "Implantate · OPG",
      blurb:
        "Familienzahnheilkunde, Mund-Kiefer-Gesichtschirurgie, Implantate und digitale OPG-Bildgebung.",
      details: [
        "Implantate & Kronen",
        "Wurzelkanalbehandlung",
        "Digitales OPG / IOPA",
        "Kinderzahnheilkunde",
      ],
      preparation: "Bringen Sie frühere Röntgenbilder und eine Liste aktueller Medikamente mit.",
    },
  },
  {
    slug: "endoscopy",
    name: "Endoscopy",
    short: "Gastro · Fibroscan",
    icon: "Microscope",
    blurb:
      "Upper GI Endoscopy, Fibroscan and Pulmonary Function Testing in a sterile day-care suite.",
    image:
      "https://images.pexels.com/photos/3845653/pexels-photo-3845653.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    details: ["Upper GI Endoscopy", "Fibroscan", "PFT", "Gastro consultation"],
    preparation:
      "Fast for 8 hours before endoscopy. A responsible attendant must accompany you.",
    de: {
      name: "Endoskopie",
      short: "Gastro · Fibroscan",
      blurb:
        "Obere GI-Endoskopie, Fibroscan und Lungenfunktionstest in einer sterilen Tagessuite.",
      details: ["Obere GI-Endoskopie", "Fibroscan", "Lungenfunktionstest", "Gastro-Sprechstunde"],
      preparation:
        "8 Stunden vor der Endoskopie nüchtern bleiben. Eine verantwortliche Begleitperson muss anwesend sein.",
    },
  },
  {
    slug: "radiology",
    name: "Radiology",
    short: "X-Ray · USG · BMD",
    icon: "Radiation",
    blurb:
      "Digital X-Ray, Ultrasound, Colour Doppler and Bone Densitometry under one roof.",
    image:
      "https://images.unsplash.com/photo-1691933880096-4046bc9e2fa0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    details: [
      "Digital X-Ray",
      "Ultrasound & Doppler",
      "Bone Mineral Densitometry",
      "Mammography (on request)",
    ],
    preparation:
      "For abdominal USG: drink water, hold urine. For pelvic USG: full bladder required.",
    de: {
      name: "Radiologie",
      short: "Röntgen · USG · Knochendichte",
      blurb:
        "Digitales Röntgen, Ultraschall, Farbdoppler und Knochendichtemessung unter einem Dach.",
      details: [
        "Digitales Röntgen",
        "Ultraschall & Doppler",
        "Knochendichtemessung",
        "Mammographie (auf Anfrage)",
      ],
      preparation:
        "Für Bauch-Ultraschall: viel Wasser trinken, Harn halten. Für Becken-Ultraschall: volle Blase erforderlich.",
    },
  },
];

// Helper: returns a service localised to the requested language
export function localiseService(svc, lang) {
  if (!svc) return svc;
  if (lang === "de" && svc.de) {
    return { ...svc, ...svc.de };
  }
  return svc;
}

export const DOCTORS = [
  { name: "Dr. Lalit Gupta", specialty: "Cardiologist", qual: "MBBS, MD, DMRD", image: "https://img1.wsimg.com/isteam/ip/a677c0cf-1124-4ab0-a6c2-e08aa9227c21/DSC07320%20copy.JPG/:/rs=w:600,cg:true" },
  { name: "Dr. Sunil Awana", specialty: "EEG Reporting", qual: "MBBS, DNB", image: "https://img1.wsimg.com/isteam/ip/a677c0cf-1124-4ab0-a6c2-e08aa9227c21/Dr%20Sunil%20Awana.jpeg/:/rs=w:600,cg:true" },
  { name: "Dr. Karuna Mathur", specialty: "Dental Surgeon", qual: "BDS, PGDPHM", image: "https://img1.wsimg.com/isteam/ip/a677c0cf-1124-4ab0-a6c2-e08aa9227c21/04.JPG/:/rs=w:600,cg:true" },
  { name: "Dr. Jinendra Jain", specialty: "Dental Surgeon", qual: "BDS, MDS (Oral & Maxillofacial)", image: "https://img1.wsimg.com/isteam/ip/a677c0cf-1124-4ab0-a6c2-e08aa9227c21/Dr.%20Jinender%20Jain.jpg/:/rs=w:600,cg:true" },
  { name: "Dr. Abha Sindhwal", specialty: "Dental Surgeon", qual: "BDS, PGDPHM", image: "https://images.unsplash.com/photo-1594824476967-48c8b964273f?w=600&q=80" },
  { name: "Dr. Ishaan Sharma", specialty: "Dental Surgeon", qual: "BDS", image: "https://img1.wsimg.com/isteam/ip/a677c0cf-1124-4ab0-a6c2-e08aa9227c21/09.JPG/:/rs=w:600,cg:true" },
  { name: "Dr. Kanika Aggarwal", specialty: "Dental Surgeon", qual: "BDS", image: "https://img1.wsimg.com/isteam/ip/a677c0cf-1124-4ab0-a6c2-e08aa9227c21/08.jpg/:/rs=w:600,cg:true" },
  { name: "Dr. Nitish Singhal", specialty: "Dermatologist", qual: "MBBS, M.DERM", image: "https://img1.wsimg.com/isteam/ip/a677c0cf-1124-4ab0-a6c2-e08aa9227c21/blob-ed32ca2.png/:/rs=w:600,cg:true" },
  { name: "Dr. Amit Aggarwal", specialty: "ENT Surgeon", qual: "MS, DNB", image: "https://img1.wsimg.com/isteam/ip/a677c0cf-1124-4ab0-a6c2-e08aa9227c21/Dr.%20Amit%20Agarwal.jpg/:/rs=w:600,cg:true" },
  { name: "Dr. Sandeep Gulati", specialty: "Gastroenterologist", qual: "MBBS, MD, DM (Gastro)", image: "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=600&q=80" },
  { name: "Dr. Sunil Arora", specialty: "Physician (TMT)", qual: "MBBS, MD (Medicine)", image: "https://img1.wsimg.com/isteam/ip/a677c0cf-1124-4ab0-a6c2-e08aa9227c21/blob-50ea7fc.png/:/rs=w:600,cg:true" },
  { name: "Dr. Pradeep Chhattree", specialty: "Nephrologist", qual: "MBBS, MD (Internal Med.)", image: "https://img1.wsimg.com/isteam/ip/a677c0cf-1124-4ab0-a6c2-e08aa9227c21/13.jpg/:/rs=w:600,cg:true" },
  { name: "Dr. Vivek Angra", specialty: "Ophthalmologist", qual: "MBBS, DOMS, DNB", image: "https://img1.wsimg.com/isteam/ip/a677c0cf-1124-4ab0-a6c2-e08aa9227c21/11.JPG/:/rs=w:600,cg:true" },
  { name: "Dr. Vivek Agarwal", specialty: "Orthopaedic Surgeon", qual: "MBBS, D.Ortho, MS", image: "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=600&q=80" },
  { name: "Dr. Vikas Dhawan", specialty: "Orthopaedic Surgeon", qual: "MBBS, MS", image: "https://img1.wsimg.com/isteam/ip/a677c0cf-1124-4ab0-a6c2-e08aa9227c21/Dr.%20Vikas%20Dhawan.jpg/:/rs=w:600,cg:true" },
  { name: "Dr. Rajan Gupta", specialty: "Pathologist", qual: "MBBS, MD (Path.)", image: "https://img1.wsimg.com/isteam/ip/a677c0cf-1124-4ab0-a6c2-e08aa9227c21/10.jpg/:/rs=w:600,cg:true" },
  { name: "Dr. Sunil Malik", specialty: "Pathologist", qual: "MBBS, MD (Path.)", image: "https://images.unsplash.com/photo-1622253692010-333f2da6031d?w=600&q=80" },
  { name: "PT. Divya Bajaj", specialty: "Physiotherapist", qual: "BPT, MPT (Ortho)", image: "https://img1.wsimg.com/isteam/ip/a677c0cf-1124-4ab0-a6c2-e08aa9227c21/06.jpg/:/rs=w:600,cg:true" },
  { name: "PT. Kashish Kalra", specialty: "Physiotherapist", qual: "BPT, MPT (Ortho)", image: "https://img1.wsimg.com/isteam/ip/a677c0cf-1124-4ab0-a6c2-e08aa9227c21/17.jpg/:/rs=w:600,cg:true" },
  { name: "Dr. Ashwani", specialty: "Physician", qual: "MBBS, DNB", image: "https://img1.wsimg.com/isteam/ip/a677c0cf-1124-4ab0-a6c2-e08aa9227c21/15.jpg/:/rs=w:600,cg:true" },
  { name: "Dr. Neeta Jain", specialty: "Physician", qual: "MBBS", image: "https://img1.wsimg.com/isteam/ip/a677c0cf-1124-4ab0-a6c2-e08aa9227c21/Dr.%20Neeta%20jain.JPG/:/rs=w:600,cg:true" },
  { name: "Dr. Rajesh Malhotra", specialty: "Radiologist", qual: "MBBS, MD", image: "https://img1.wsimg.com/isteam/ip/a677c0cf-1124-4ab0-a6c2-e08aa9227c21/12.jpg/:/rs=w:600,cg:true" },
  { name: "Dr. Jyotika Gulati", specialty: "Radiologist", qual: "MBBS, MD (Radio-Diag.)", image: "https://img1.wsimg.com/isteam/ip/a677c0cf-1124-4ab0-a6c2-e08aa9227c21/Dr.%20Jyotika%20Gulati-e4e1a38.JPG/:/rs=w:600,cg:true" },
  { name: "Dr. Rekha Sharma", specialty: "Radiologist", qual: "MBBS, MD (Radio-Diag.)", image: "https://img1.wsimg.com/isteam/ip/a677c0cf-1124-4ab0-a6c2-e08aa9227c21/07.jpg/:/rs=w:600,cg:true" },
  { name: "Dr. Leena Gupta", specialty: "Ultrasonologist", qual: "MBBS, DNB-I", image: "https://img1.wsimg.com/isteam/ip/a677c0cf-1124-4ab0-a6c2-e08aa9227c21/14.jpg/:/rs=w:600,cg:true" },
];

export const SPECIALTIES = [
  "All", "Cardiologist", "Dental Surgeon", "Dermatologist", "ENT Surgeon",
  "Gastroenterologist", "Nephrologist", "Ophthalmologist",
  "Orthopaedic Surgeon", "Pathologist", "Physician", "Physiotherapist",
  "Radiologist", "Ultrasonologist", "EEG Reporting"
];

export const OPD_TIMINGS = [
  { day: "Monday", time: "09:00 AM – 12:00 PM" },
  { day: "Tuesday", time: "09:00 AM – 12:00 PM" },
  { day: "Wednesday", time: "09:00 AM – 12:00 PM" },
  { day: "Thursday", time: "09:00 AM – 12:00 PM" },
  { day: "Friday", time: "09:00 AM – 12:00 PM" },
  { day: "Saturday", time: "09:00 AM – 12:00 PM" },
  { day: "Sunday", time: "Closed" },
];

export const REPORT_TIMINGS = [
  { label: "Morning Collection", time: "09:00 AM – 1:00 PM" },
  { label: "Evening Collection", time: "05:30 PM – 7:00 PM" },
];

export const TESTIMONIALS = [
  {
    name: "Sushma Arora",
    role: "Patient · Krishna Nagar",
    text:
      "The MRI was completed in just 30 minutes and the report was ready the very next morning. The staff treated my mother like family — I'm deeply grateful.",
  },
  {
    name: "Rajeev Kapoor",
    role: "Son of dialysis patient",
    text:
      "Free dialysis sessions for my father changed our lives. The ward is spotless and the nurses are exceptionally caring. Truly a blessing for working families.",
  },
  {
    name: "Dr. Anita Mehta",
    role: "Referring Physician",
    text:
      "I confidently send my patients here for CT and pathology. The accuracy, turnaround time and charitable pricing are unmatched in East Delhi.",
  },
  {
    name: "Pooja Sharma",
    role: "Dental Patient",
    text:
      "From OPG to a root canal, every step was explained patiently. Modern equipment with the warmth of a community centre — this is rare.",
  },
];

export const GALLERY = [
  { src: "https://img1.wsimg.com/isteam/ip/a677c0cf-1124-4ab0-a6c2-e08aa9227c21/maingate.jpg/:/rs=w:900,cg:true", caption: "Centre entrance" },
  { src: "https://img1.wsimg.com/isteam/ip/a677c0cf-1124-4ab0-a6c2-e08aa9227c21/OPD1-ac36ba4.png/:/rs=w:900,cg:true", caption: "OPD waiting area" },
  { src: "https://img1.wsimg.com/isteam/ip/a677c0cf-1124-4ab0-a6c2-e08aa9227c21/1Img.webp/:/rs=w:900,cg:true", caption: "Diagnostic floor" },
  { src: "https://img1.wsimg.com/isteam/ip/a677c0cf-1124-4ab0-a6c2-e08aa9227c21/mri-magnetom-essenza-dot-product-image-sh_mr_3.TIF/:/rs=w:900,cg:true", caption: "1.5 Tesla MRI" },
  { src: "https://img1.wsimg.com/isteam/ip/a677c0cf-1124-4ab0-a6c2-e08aa9227c21/Small%20-%2072%20DPI-SH_CT_42161_16.TIF.jpg/:/rs=w:900,cg:true", caption: "16-Slice CT" },
  { src: "https://img1.wsimg.com/isteam/ip/a677c0cf-1124-4ab0-a6c2-e08aa9227c21/3img.png/:/rs=w:900,cg:true", caption: "Patient care" },
  { src: "https://images.unsplash.com/photo-1582719471384-894fbb16e074?w=900&q=80", caption: "Pathology lab" },
  { src: "https://images.unsplash.com/photo-1615461065929-4f8ffed6ca40?w=900&q=80", caption: "Dialysis ward" },
];

export const WHY_CHOOSE = [
  { title: "NABL Accredited", desc: "Our Path Lab meets the highest national quality benchmarks for diagnostic accuracy.", icon: "ShieldCheck" },
  { title: "State-of-the-Art Technology", desc: "1.5 Tesla MRI, 16-Slice CT, fully automated pathology and digital radiology.", icon: "Sparkles" },
  { title: "Expert Medical Team", desc: "30+ super-specialists, radiologists and technicians with decades of experience.", icon: "Stethoscope" },
  { title: "Charitable, Nominal Pricing", desc: "Run by a charitable trust — premium diagnostics at a fraction of private hospital costs.", icon: "HeartHandshake" },
  { title: "Free Dialysis Programme", desc: "Hemodialysis offered free of cost to those in need — service to humanity in action.", icon: "Droplets" },
  { title: "70 Years of Trust", desc: "Established in 1954 by Shri Paramhans Advait Math — generations of healing.", icon: "Award" },
];
